import React, { useContext } from 'react';
// Vendor
/* import { useSelector, useDispatch } from 'react-redux'; */
import { useParams } from 'react-router';


/* import { db } from 'utils/firebase'; */
import {
  /* useDbInvoices, */
  DbInvoicesContext
} from 'utils/firebase';
import AppLoader from 'components/loaders/AppLoader';
import InvoiceView from './InvoiceView';


// Component
function InvoiceDetails() {
  const { id } = useParams();

  const {InvoicesLoading, Invoices} = useContext(DbInvoicesContext);

  const invoiceArray =  Invoices.filter(function(invoice) {
    return invoice.id === id;
});

const invoice = invoiceArray[0]




/* console.log("pdf invoice", invoice); */

  /* const loadingState = useSelector((state) => state.loadingState.emailSendBtn); */

  if (InvoicesLoading) return <AppLoader />;

  /* const handleDeleteInvoice = () => {
    dispatch(confirmDeleteAction(deleteInovice(id)));
  };

  const handleEmailInvoice = () => {
    dispatch(confirmEmailReminder(sendInvoiceMail(id)));
  };

  const handlePaymentStatus = () => {
    dispatch(
      confirmPaymentChangeAction(updatePaymentStatus(id, !invoice.paidStatus))
    );
  }; */



  return (
    <div>
      {/* <Header title={'Invoice Details'} /> */}
     {/*  <InvoicePD invoice={invoice} /> */}
     <InvoiceView invoice={invoice} InvoicesLoading={InvoicesLoading} ></InvoiceView>
    </div>
  );
}

export default InvoiceDetails;
